/**
 * Time - Represents time estimation information for pay items.
 * Used to track unit production rates, workforce factors, and calculated item time.
 */
export class Time {
  /** Engineer's estimated units per day */
  EngEstUnitPerDay: number;

  /** Override value for units per day */
  UnitOverride: number;

  /** Unit factor for time calculation */
  UnitFactor: number;

  /** Workforce factor for time calculation */
  WorkforceFactor: number;

  /** Calculated units per day */
  UnitPerDay: number;

  /** Final calculated item time */
  ItemTime: number;

  /**
   * Creates a new Time instance
   * @param data - Object containing time properties
   */
  constructor(data: {
    EngEstUnitPerDay: number;
    UnitOverride: number;
    UnitFactor: number;
    WorkforceFactor: number;
    UnitPerDay: number;
    ItemTime: number;
  }) {
    this.EngEstUnitPerDay = data.EngEstUnitPerDay;
    this.UnitOverride = data.UnitOverride;
    this.UnitFactor = data.UnitFactor;
    this.WorkforceFactor = data.WorkforceFactor;
    this.UnitPerDay = data.UnitPerDay;
    this.ItemTime = data.ItemTime;
  }

  /**
   * Creates a Time from a plain object (useful for deserialization)
   * @param obj - Plain object with time data
   * @returns New Time instance
   */
  static fromObject(obj: Partial<Time>): Time {
    return new Time({
      EngEstUnitPerDay: obj.EngEstUnitPerDay ?? 0,
      UnitOverride: obj.UnitOverride ?? 0,
      UnitFactor: obj.UnitFactor ?? 0,
      WorkforceFactor: obj.WorkforceFactor ?? 0,
      UnitPerDay: obj.UnitPerDay ?? 0,
      ItemTime: obj.ItemTime ?? 0,
    });
  }

  /**
   * Converts the Time to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      EngEstUnitPerDay: this.EngEstUnitPerDay,
      UnitOverride: this.UnitOverride,
      UnitFactor: this.UnitFactor,
      WorkforceFactor: this.WorkforceFactor,
      UnitPerDay: this.UnitPerDay,
      ItemTime: this.ItemTime,
    };
  }
}


